import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, HostListener, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface BudgetItem {
    category: string;
    totalAmount: string;
    spentAmount: string;
    percentage: number;
    isPinned: boolean;
}

@Component({
    selector: 'app-budget-status-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './budget-status-modal.html',
    styleUrl: './budget-status-modal.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BudgetStatusModalComponent implements OnInit {
    @Input() isOpen: boolean = false;
    @Output() close = new EventEmitter<void>();

    budgetItems: BudgetItem[] = [];
    isLoading: boolean = false;
    isAddBudgetOpen: boolean = false;
    isDropdownOpen: boolean = false;
    selectedCategory: string = '';
    categories: string[] = ['Overall Budget', 'Entertainment', 'Food', 'Travel', 'Shopping', 'Bills'];
    mockBudgets: BudgetItem[] = [
        {
            category: 'Food',
            totalAmount: '₹5,505,000.35',
            spentAmount: '₹5,505,000.35',
            percentage: 25,
            isPinned: true
        },
        {
            category: 'Overall Budget',
            totalAmount: '₹5,505,000.35',
            spentAmount: '₹5,000.35',
            percentage: 50,
            isPinned: false
        },
        {
            category: 'Travel',
            totalAmount: '₹5,505,000.35',
            spentAmount: '₹6,606,000.42',
            percentage: 120,
            isPinned: false
        }
    ];

    constructor(
        private cdr: ChangeDetectorRef
    ) { }

    @ViewChild('dropdownRef') dropdownRef!: ElementRef;

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (this.isDropdownOpen && this.dropdownRef && !this.dropdownRef.nativeElement.contains(event.target)) {
            this.isDropdownOpen = false;
        }
    }

    onContainerClick(event: MouseEvent) {
        event.stopPropagation();
        if (this.isDropdownOpen && this.dropdownRef && !this.dropdownRef.nativeElement.contains(event.target)) {
            this.isDropdownOpen = false;
        }
    }

    ngOnInit() {
        this.loadBudgets();
    }

    loadBudgets() {
        this.isLoading = true;
        this.cdr.markForCheck();

        // Use mock data directly instead of calling an API service
        setTimeout(() => {
            this.budgetItems = this.mockBudgets;
            this.isLoading = false;
            this.cdr.markForCheck();
        }, 300);
    }

    onClose() {
        if (this.isAddBudgetOpen) {
            this.isAddBudgetOpen = false;
        } else {
            this.close.emit();
        }
        this.cdr.markForCheck();
    }

    togglePin(item: BudgetItem) {
        item.isPinned = !item.isPinned;
        this.cdr.markForCheck();
    }

    onEdit(item: BudgetItem) {
    }

    onAddNewBudget() {
        this.isAddBudgetOpen = true;
        this.cdr.markForCheck();
    }

    onSaveBudget() {
        this.isAddBudgetOpen = false;
        this.cdr.markForCheck();
    }
}

